import { render, staticRenderFns } from "./declarations.vue?vue&type=template&id=3aed9338&"
import script from "./declarations.vue?vue&type=script&lang=js&"
export * from "./declarations.vue?vue&type=script&lang=js&"
import style0 from "./declarations.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports